export enum PricingMethod {
    PerTradeLane = 'PER_TRADE_LANE',
    PerUnit = 'PER_UNIT',
}